import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-chat-smile-2-line"></i>
            吃瓜现场
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">大家正在热议</h2>
          <p className="mt-3 text-sm text-foreground-600">来自吃瓜群众的第一手评论</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="flex gap-4 bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-background-200">
                <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
                <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                  <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-thumb-up-line"></i> {comment.likes}
                  </button>
                  <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-chat-1-line"></i> 回复
                  </button>
                  <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-share-forward-line"></i> 分享
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}